// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nav-search-icon[data-v-9e8fa1d4]{color:#fff;cursor:pointer;display:flex;flex-direction:column;justify-content:center}.nav-search-icon[data-v-9e8fa1d4]:hover{color:#dadada}.img-esic[data-v-9e8fa1d4]{height:50px}", ""]);
// Exports
module.exports = exports;
